import React from "react";
import PACEEcosystemPNG from "../../assets/section_new_images/PACE Ecosystem.png";

const WhyStepSkills = () => {
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center flex-column flex-md-row py-5"
        style={{ borderBottom: "1px solid #8E8E8E" }}
      >
        <div className="col-12 col-md-6 px-5">
          <div className="pb-3">
            <span className="headerText">Why STEPskills ?</span>
          </div>
          <span
            className="contentText"
            style={{ font: "400 clamp(1rem,2vw,1.7rem)/normal Nunito" }}
          >
            The STEPapp ecosystem is a revolutionary step towards democratizing
            world-class education and bringing about a level playing field for
            all students alike. With the implementation of the New Education
            Policy and the global shift towards skill based education, at
            STEPapp we want to focus on nurturing the inquisitive and creative
            minds of the young children.
          </span>
        </div>
        <div className="col-12 col-md-6">
          <img
            src={PACEEcosystemPNG}
            className="d-block mx-auto"
            style={{ maxWidth: "300px" }}
            alt="img"
          />
        </div>
      </div>
    </>
  );
};

export default WhyStepSkills;
